import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import EnhancedToolbar from '../../widgets/Toolbar';
import "./../../Grid.css";
import "./../../Form.css";
import "./../../App.css";
import { ViewContainer } from "./../../View.jsx";
import ViewUtils from "./../../ViewUtils";
import AlertItem from "../../widgets/AlertItem";
import { LearnerWorkExperienceForm } from '../../etqa/program/registration/LearnerWorkExperienceForm';

const WorkExperienceRef = React.createRef();
const utils = new ViewUtils();

class AddLearnerWorkExperience extends Component {

    state = {
        WorkExperienceDetails: {
            SAQAQualificationTitle: "",
            SAQAQualificationID: ""
        },
        messageStyle: "message",
        id: null,
        showTable: true,
        CurrentProgramme: this.props.location.state.WorkExperienceID,
        CreateNewFlag: this.props.location.state.hideFields,
        Learner: this.props.location.state.LearnerID,
        toolbarConfig: {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: '', tooltip: 'Close', icon: 'CloseIcon' }
                    ]
                }
                ,
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'save', label: '', tooltip: 'Save', icon: 'SaveIcon' },
                        { id: 'documents', label: 'DOCUMENTS', tooltip: 'Documents', disabled: (this.props.location.state.hideFields), visible: !(this.props.location.state.hideFields) }
                    ]
                }
            ]
        },
        model:{ },
    };

    componentDidMount() {
        if (utils.isNull(this.props.location.state.WorkExperienceID) || this.props.location.state.WorkExperienceID === 0)
        {
            this.defaultSponsorship()
        }
    }

    handleFormValueChange = (values) => {
        if (!utils.isNull(values)) {
            //if (!utils.isNull(values.StartDate)) {
            //    if (values.WorkExperienceID.Description.includes("WE5")) {
            //        utils.autoSetDate(this, WorkExperienceRef, values.StartDate, 1, 6, 0, "EndDate", "StartDate")
            //    }
            //    else if (values.WorkExperienceID.Description.includes("WE")) {
            //        utils.autoSetDate(this, WorkExperienceRef, values.StartDate, 1, 0, 0, "EndDate", "StartDate")
            //    }
            //    else if (values.WorkExperienceID.Description.includes("WE1")) {
            //        utils.autoSetDate(this, WorkExperienceRef, values.StartDate, 1, 0, 0, "EndDate", "StartDate")
            //    }
            //    else if (values.WorkExperienceID.Description.includes("WE2")) {
            //        utils.autoSetDate(this, WorkExperienceRef, values.StartDate, 1, 0, 0, "EndDate", "StartDate")
            //    }
            //    else if (values.WorkExperienceID.Description.includes("VW")) {
            //        utils.autoSetDate(this, WorkExperienceRef, values.StartDate, 0, 2, 0, "EndDate", "StartDate")
            //    }
            //    else if (values.WorkExperienceID.Description.includes("TVET")) {
            //        utils.autoSetDate(this, WorkExperienceRef, values.StartDate, 2, 0, 0, "EndDate", "StartDate")
            //    }
            //    else  {
            //        utils.autoSetDate(this, WorkExperienceRef, values.StartDate, 0, 6, 0, "EndDate", "StartDate")
            //    }
            //}


            this.setState({
                WorkExperienceSetupDetails: {
                    SAQAQualificationID: values.SAQAQualificationID,
                    SAQAQualificationTitle: values.SAQAQualificationTitle
                },
                Learner: this.props.location.state.LearnerID
            });

            this.ECCheck(values);
        }
    }

    ECCheck(values) {
        if (!utils.isNull(values)) {
            if (!utils.isNull(values.EmployerID)) {
                let url = "api/sims/learner/EmployerContactCheck?EmployerID=" + values.EmployerID.Id;
                utils.invokeUrl(url, (response) => {
                    if (response.Result != "") {
                        this.setState({
                            message: response.Result,
                            messageStyle: "ERROR",
                        })
                    }
                },
                    null,
                    {
                        method: 'GET',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': "Bearer " + localStorage.getItem("token")
                        }
                    }
                )
            }
        }
    }

    dateChange = (form, date) => {

        if (!utils.isNull(form.values.StartDate)) {
            if (form.values.WorkExperienceID.Description.includes("PTL5")) {
                utils.autoSetDate(this, WorkExperienceRef, form.values.StartDate, 1, 6, 0, "EndDate", "StartDate")
            }
            else if (form.values.WorkExperienceID.Description.includes("PTL1")) {
                utils.autoSetDate(this, WorkExperienceRef, form.values.StartDate, 1, 0, 0, "EndDate", "StartDate")
            }
            else if (form.values.WorkExperienceID.Description.includes("PTL2")) {
                utils.autoSetDate(this, WorkExperienceRef, form.values.StartDate, 1, 0, 0, "EndDate", "StartDate")
            }
            else if (form.values.WorkExperienceID.Description.includes("PTL4")) {
                utils.autoSetDate(this, WorkExperienceRef, form.values.StartDate, 0, 6, 0, "EndDate", "StartDate")
            }
            else if (form.values.WorkExperienceID.Description.includes("PTL3")) {
                utils.autoSetDate(this, WorkExperienceRef, form.values.StartDate, 0, 6, 0, "EndDate", "StartDate")
            }
            else if (form.values.WorkExperienceID.Description.includes("PTL")) {
                utils.autoSetDate(this, WorkExperienceRef, form.values.StartDate, 1, 0, 0, "EndDate", "StartDate")
            }
            else if (form.values.WorkExperienceID.Description.includes("VW")) {
                utils.autoSetDate(this, WorkExperienceRef, form.values.StartDate, 0, 2, 0, "EndDate", "StartDate")
            }
            else if (form.values.WorkExperienceID.Description.includes("TVET")) {
                utils.autoSetDate(this, WorkExperienceRef, form.values.StartDate, 2, 0, 0, "EndDate", "StartDate")
            }
            else {
                utils.autoSetDate(this, WorkExperienceRef, form.values.StartDate, 0, 6, 0, "EndDate", "StartDate")
            }
        }
    }


    handleToolbarButtonClick(buttonId) {
        if ("save" === buttonId) {
            this.save();
        } else if ("close" === buttonId) {
            this.closeView();
        } else if ("documents" === buttonId) {
            this.props.history.push({
                pathname: '/learnerWorkExperienceDocuments',
                state: {
                    LearnerID: this.props.location.state.LearnerID,
                    LearnerWorkExperienceID: this.props.location.state.WorkExperienceID,
                    hideFields: false,
                    learnerNames: this.props.location.state.learnerNames,
                    permissions: this.props.location.state.permissions
                }
            });
        }
    }

    successCallback = (response) => {
        if (response.MessageType === "SUCCESS") {
            this.setState({
                showTable: false
            }, () => {
                this.setState({
                    showTable: true,
                    message: response.Message,
                    messageStyle: response.MessageType,
                    CurrentProgramme: response.EntityId,
                    CreateNewFlag: false
                })
            });
        }
        else {
            this.setState({
                message: response.Message, messageStyle: response.MessageType
            });
        }
    }

    defaultSponsorship = () => {
        let url = "api/sims/LearnerWorkExperience/GetCurrentRole";
        utils.invokeUrl(url, (response) => {
            if (response.Result === "Provider" || response.Result === "AET Agent" || response.Result === "Agent") {
                this.setState({
                    model: {
                        SponsorshipID: { Id: 2, Description: "Industry Funded" }
                    }
                })
            }
        },
            null,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                }
            }
        )
    }

    save() {
        let formValue = WorkExperienceRef.current.getValue();
        if (formValue !== null && typeof formValue !== "undefined") {
            formValue.id = this.props.location.state.LearnerID;
            let input = JSON.stringify(formValue);

            utils.invokeUrl("api/sims/learnerWorkExperience/LinkLearnerWorkExperience", (response) => {
                this.successCallback(response);
            }, () => { alert(utils.SYSTEM_ERROR_MESSAGE) }, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    "Authorization": "Bearer " + localStorage.getItem("token")
                },
                body: input
            });
        }
    }

    closeView() {

        this.props.history.push({
            pathname: '/LearnerWorkExperienceSearch',
            state: {
                learnerID: this.props.location.state.LearnerID,
                learnerNames: this.props.location.state.learnerNames
            }
        });
    }

    render() {
        return (
            <ViewContainer topPadding="0" title="">
                <p className="breadcrumbs">
                    {
                        (this.props.location.state.hideFields) ?
                            `Learner > Link New Work Experience > ${this.props.location.state.learnerNames}`
                            :
                            `Learner > Update Work Experience > ${this.props.location.state.learnerNames}`
                    }
                </p>
                <AlertItem message={this.state.message} alertStyle={this.state.messageStyle} />
                <table width="100%">
                    <tbody>
                        <tr>
                            <td>
                                <EnhancedToolbar highlight={false}
                                    title=""
                                    buttonClickHandler={(buttonId) => this.handleToolbarButtonClick(buttonId)}
                                    config={this.state.toolbarConfig} />
                            </td>
                        </tr>
                        <tr>
                            <td className="formContainer">
                                <div style={{ height: "65%", maxHeight: "60vh" }}>
                                    {this.state.showTable === true && (
                                        <LearnerWorkExperienceForm ref={WorkExperienceRef}
                                            viewRef={this}
                                            id={this.state.CurrentProgramme}
                                            editPermission={this.props.location.state.permissions}
                                            viewOnly={this.props.location.state.viewOnly}
                                            hideFields={this.state.CreateNewFlag}
                                            valueChangeHandler={(values) => this.handleFormValueChange(values)}
                                            dateChange={this.dateChange}
                                            model={this.state.model}
                                            data={this.state.model}
                                        />
                                    )}
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ViewContainer>
        );
    }
}

export default withRouter(AddLearnerWorkExperience);
